<template>
  <div class="mid-bar-text">
    <div class="mid-bar-text__bar" />
    <span class="mid-bar-text__text">
      <slot />
    </span>
    <div class="mid-bar-text__bar" />
  </div>
</template>

<script lang="ts">
export default {}
</script>

<style lang="scss">
@use "~/common/scss/variables";

.mid-bar-text {
  align-items: center;
  color: variables.$colorGrey;
  display: flex;
  gap: .5rem;
  padding: 1.5rem 0;
  border: 0;

  &__bar {
    background-color: variables.$colorGreyBorder;
    height: 1px;
    width: 100%;
  }

  &__text {
    text-transform: uppercase;
    white-space: nowrap;
  }
}
</style>
